import { COU_httpGet2 } from "@/utils/http";

//货盘来源list  navlist
export function getResourceList(data) {
  return COU_httpGet2({ url: "/xfadmin/config?appType=2&key=xfzfb", data: { appType: data }, normalUrl: true });
}
